import { searchRoutes } from '@/Search/search.routes';
const searchModule = {
    routes: searchRoutes
};
export default searchModule;
